import { useAppSelector } from 'utils/redux/useAppSelector';
import { currentUserRole } from '../currentUserRole/currentUserRole';
/** A hook for getting various information on the currently logged in user. */
export const useCurrentUser = () => {
    const user = useAppSelector((state) => state.settings.profile.profile);
    const currentRole = currentUserRole(user);
    return { user, currentRole };
};
